export interface DashboardRestoreState {
  searchTerm: string
  currentPage: number
  statusFilter: string
  categoryFilter: string
  jobTypeFilter: string
  activeInactiveFilter: string
  publishedFilter: string
  itemsPerPage: number
}

export function isDashboardRestoreState(value: unknown): value is DashboardRestoreState {
  if (!value || typeof value !== "object") {
    return false
  }
  const state = value as DashboardRestoreState
  return typeof state.currentPage === "number"
}
